import { useId } from "react";
import { MapPin } from "lucide-react";

const inputCls = "fundio-input";
const labelCls = "fundio-field-label";

// MULTI-only Standort picker for Fundstücke. Single tenants never render this.
export function LocationSelect({ locations = [], value, onChange, required = false, disabled = false }) {
  const id = useId();
  return (
    <div data-testid="item-location-field">
      <label htmlFor={id} className={labelCls}>
        <span className="inline-flex items-center gap-1"><MapPin size={12} /> Standort{required ? " *" : ""}</span>
      </label>
      <select
        id={id}
        required={required}
        data-testid="item-location-select"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`${inputCls} mt-1.5 disabled:opacity-60`}
      >
        <option value="">Standort wählen …</option>
        {locations.map((l) => (
          <option key={l.id} value={l.id}>{l.name}{l.city ? ` · ${l.city}` : ""}</option>
        ))}
      </select>
    </div>
  );
}
